// extracted by mini-css-extract-plugin
export default {"SolanaToast":"SolanaToast_HudU2","appear":"appear_Vfvkh","button":"button_HLFf4","icons":"icons_uCvey","sol":"sol__WATD","ton":"ton_x4uyJ","compressed":"compressed_usO9W"};